// Every ported screen, by its canvas number. The router reads #/AppNN.
import { SoundLab } from "./SoundLab.js";
import { App01_Splash } from "./App01-Splash.js";
import { App02_HowItWorks } from "./App02-HowItWorks.js";
import { App03_Landing } from "./App03-Landing.js";
import { App04_ConnectWallet } from "./App04-ConnectWallet.js";
import { App05_Screening } from "./App05-Screening.js";
import { App08_ProfileSetup } from "./App08-ProfileSetup.js";
import { App09_Lobby } from "./App09-Lobby.js";
import { App10_CallSide } from "./App10-CallSide.js";
import { App10w_SomeoneWaiting } from "./App10w-SomeoneWaiting.js";
import { App11_Matchmaking } from "./App11-Matchmaking.js";
import { App12_Versus } from "./App12-Versus.js";
import { App14_Arena } from "./App14-Arena.js";
import { App15_FinalSeconds } from "./App15-FinalSeconds.js";
import { App16_Settling } from "./App16-Settling.js";
import { App17_Victory } from "./App17-Victory.js";
import { App18_Roast } from "./App18-Roast.js";
import { App19_Draw } from "./App19-Draw.js";
import { App20_SharePreview } from "./App20-SharePreview.js";
import { App21_ChallengeFriend } from "./App21-ChallengeFriend.js";
import { App21b_ChallengeLive } from "./App21b-ChallengeLive.js";
import { App22_IncomingChallenge } from "./App22-IncomingChallenge.js";
import { App22b_ChallengeTaken, App22c_ChallengeExpired } from "./App22b-ChallengeTaken.js";
import { App23_Leaderboard } from "./App23-Leaderboard.js";
import { App25_History } from "./App25-History.js";
import { App24_Profile } from "./App24-Profile.js";
import { App27_Referrals } from "./App27-Referrals.js";
import { App28_Wallet } from "./App28-Wallet.js";
import { App28a_Activity } from "./App28a-Activity.js";
import { App36_OpponentLeft } from "./App36-OpponentLeft.js";
import { App37_EmptyHistory } from "./App37-EmptyHistory.js";
import { App38_CustomStake } from "./App38-CustomStake.js";
import { App39_Deposit } from "./App39-Deposit.js";
import { App40_Withdraw } from "./App40-Withdraw.js";
import { App47_AgeGate } from "./App47-AgeGate.js";
import { App50_NoOpponent } from "./App50-NoOpponent.js";
import { App52_OracleRefund } from "./App52-OracleRefund.js";
import { App53_DailyLimit } from "./App53-DailyLimit.js";
import { App54_OnBreak } from "./App54-OnBreak.js";
import { App58_PlayLimits } from "./App58-PlayLimits.js";
import { App60_PartnerApply } from "./App60-PartnerApply.js";
import { App61_PartnerStatus } from "./App61-PartnerStatus.js";
import { App55_DepositPending } from "./App55-DepositPending.js";
import { App56_WithdrawFailed } from "./App56-WithdrawFailed.js";
import { App64_NotifyPermission } from "./App64-NotifyPermission.js";
import { App70_DepositSuccess } from "./App70-DepositSuccess.js";
import { App71_WithdrawSuccess } from "./App71-WithdrawSuccess.js";
import { App72_JoinChannel } from "./App72-JoinChannel.js";
import { App73_RejoinChannel } from "./App73-RejoinChannel.js";
import { App74_DepositAddress } from "./App74-DepositAddress.js";
import { App75_WithdrawPaused } from "./App75-WithdrawPaused.js";
import { App76_Chart } from "./App76-Chart.js";
import { App77_ChartFull } from "./App77-ChartFull.js";
import { App42_Tournaments, App43_Tournament, App44_TournamentLive, App45_TournamentResult } from "./Tournaments.js";
import { App30_Store, App31b_Badges } from "./Store.js";

export const SCREENS: Record<string, () => JSX.Element | null> = {
  App01: App01_Splash,
  App02: App02_HowItWorks,
  App03: App03_Landing,
  App04: App04_ConnectWallet,
  App05: App05_Screening,
  App08: App08_ProfileSetup,
  App09: App09_Lobby,
  App10: App10_CallSide,
  App10w: App10w_SomeoneWaiting,
  App11: App11_Matchmaking,
  App12: App12_Versus,
  App14: App14_Arena,
  App15: App15_FinalSeconds,
  App16: App16_Settling,
  App17: App17_Victory,
  App18: App18_Roast,
  App19: App19_Draw,
  App20: App20_SharePreview,
  App21: App21_ChallengeFriend,
  App21b: App21b_ChallengeLive,
  App22: App22_IncomingChallenge,
  App22b: App22b_ChallengeTaken,
  App22c: App22c_ChallengeExpired,
  App23: App23_Leaderboard,
  App25: App25_History,
  App24: App24_Profile,
  App27: App27_Referrals,
  App28: App28_Wallet,
  App28a: App28a_Activity,
  App36: App36_OpponentLeft,
  App37: App37_EmptyHistory,
  App38: App38_CustomStake,
  App39: App39_Deposit,
  App40: App40_Withdraw,
  App47: App47_AgeGate,
  App50: App50_NoOpponent,
  App52: App52_OracleRefund,
  App53: App53_DailyLimit,
  App54: App54_OnBreak,
  App55: App55_DepositPending,
  App58: App58_PlayLimits,
  App30: App30_Store,
  App31b: App31b_Badges,
  App42: App42_Tournaments,
  App43: App43_Tournament,
  App44: App44_TournamentLive,
  App45: App45_TournamentResult,
  App60: App60_PartnerApply,
  App61: App61_PartnerStatus,
  App56: App56_WithdrawFailed,
  App64: App64_NotifyPermission,
  App70: App70_DepositSuccess,
  App71: App71_WithdrawSuccess,
  App72: App72_JoinChannel,
  App73: App73_RejoinChannel,
  App74: App74_DepositAddress,
  App75: App75_WithdrawPaused,
  App76: App76_Chart,
  App77: App77_ChartFull,
};

// Test server only: #/SoundLab tries every sound and haptic on a real phone.
if (import.meta.env.DEV) SCREENS.SoundLab = SoundLab;
